import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';

import {
  GiftStoreBannerCreate,
  GiftStoreBannerData,
  GiftStoreBannerPublic,
  GiftStoreBannerUpdate,
} from './giftStoreBanner.interface';

// 배너 API가 아직 배포되지 않은 구서버 — 호출부는 기본 배너/미배포 안내로 폴백한다
export const isGiftStoreBannerUnsupported = (error: unknown): boolean =>
  (error as { response?: { status?: number } })?.response?.status === 404;

/**
 * 고객 스토어 배너 (켜짐 + 기간 안 + 대상 상조 필터는 서버가 한다).
 * 구서버(404)면 null — 스토어는 기본 배너 이미지를 보여준다.
 */
export const fetchGiftStoreBannersByBugo = async (
  bugoId: string,
): Promise<GiftStoreBannerPublic[] | null> => {
  try {
    const { data } = await api_.get<GiftStoreBannerPublic[]>(
      `/public/gift-store-banner/by-bugo?bugo=${encodeURIComponent(bugoId)}`,
    );
    return Array.isArray(data) ? data : [];
  } catch (error) {
    if (isGiftStoreBannerUnsupported(error)) return null;
    throw error;
  }
};

export const fetchAdminGiftStoreBanners = async (): Promise<GiftStoreBannerData[]> => {
  const { data } = await api_.get<GiftStoreBannerData[]>(
    `/admin/gift-store-banner?${queryString({
      populate: ['image'],
      options: { sort: { order: 1, createdAt: 1 } },
    })}`,
  );
  return Array.isArray(data) ? data : [];
};

export const createGiftStoreBanner = async (
  dto: GiftStoreBannerCreate,
): Promise<GiftStoreBannerData> => {
  const { data } = await api_.post<GiftStoreBannerData>('/admin/gift-store-banner', dto);
  return data;
};

export const updateGiftStoreBanner = async (
  id: string,
  dto: GiftStoreBannerUpdate,
): Promise<GiftStoreBannerData> => {
  const { data } = await api_.patch<GiftStoreBannerData>(
    `/admin/gift-store-banner/${id}`,
    dto,
  );
  return data;
};

export const deleteGiftStoreBanner = async (id: string): Promise<void> => {
  await api_.delete(`/admin/gift-store-banner/${id}`);
};

export const reorderGiftStoreBanners = async (
  ids: string[],
): Promise<{ updated: number }> => {
  const { data } = await api_.post('/admin/gift-store-banner/reorder', { ids });
  return data;
};
